import React, {useEffect, useState} from 'react';
import './NotificationModal.scss'
import {useDispatch, useSelector} from "react-redux";
import {sendNotificationForLastComment, sendNotificationForSpecificComment} from "../store/actions/commentsActions";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const NotificationModal = props => {
    const { t } = useSelector(selector);
    const {selectedComment, closeMethod} = props;
    const [formValues, setFormValues] = useState({
        ipsadPostId: null,
        notificationTitle: 'Nowy artykuł',
        notificationBody: ''
    });

    const dispatch = useDispatch();

    useEffect(() => {
        if(selectedComment) {
            setFormValues({
                ipsadPostId: selectedComment.id,
                notificationTitle: '',
                notificationBody: ''
            })
        }
    },[])

    const sendNotificationForLastCommentClick =  () => {
        if(selectedComment) {
            dispatch(sendNotificationForSpecificComment(formValues, closeMethod));
        } else {
            dispatch(sendNotificationForLastComment(formValues, closeMethod));
        }

    }

    return (
        <div className="modalBlur">
            <div className="NotificationModal">
                <div className="NotificationModalHeader">
                    {t.gettext('Add notification')}
                    <button className="modalCloseButton" onClick={closeMethod}>×</button>
                </div>
                <form className="notificationModalForm">
                    <div className="notificationModalItem">
                        <label className="notificationLabel">{t.gettext('Title')}</label>
                        <input
                            type="text"
                            value={formValues.notificationTitle}
                            onChange={e => setFormValues({...formValues, notificationTitle: e.target.value})}
                        />
                    </div>
                    <div className="notificationModalItem">
                        <label className="notificationLabel">{t.gettext('Message')}</label>
                        <input
                            type="text"
                            value={formValues.notificationBody}
                            onChange={e => setFormValues({...formValues, notificationBody: e.target.value})}
                        />
                    </div>
                    <div className="modalButtons">
                        <button type="button" className="btnClose" onClick={closeMethod}>
                            {t.gettext('Close')}
                        </button>
                        <button type="button" className="btnSave" onClick={sendNotificationForLastCommentClick}>
                            {t.gettext('Send')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default NotificationModal;
